export default {
  "meta-title": "TARISLAND",
  "meta-description": "Tarisland is a classic MMORPG on PC and mobile devices, featuring raids, diverse classes, crossplay and a vast world for exploration. Embark on your epic adventure together.",
  "meta-keywords": "tarisland,taris,comme wow,mmo,mmorpg,multiplateforme,mmomobile,mmoPC",
  "meta-name": "Tarisland Official Website",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "Tarisland Official Website",
  "meta-og-title": "Tarisland Official Website",
  "meta-og-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "Tarisland Official Website",
  "meta-twitter-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",

  "email_illegal": "Incorrect Email address. Please check and resubmit it.",
  "horizon_tip": "For a better experience, please rotate your device.",

  'downloadPc': "Please download on PC",

  "area": "Area",
  "select-area": "Pilih area",
  "server": "Server",
  "select-server": "Pilih server",
  "character-name": "Nama Karakter",
  "select-character": "Pilih karakter",
  "please-select": "Silakan pilih",
  "not-found-role": "Informasi karakter tidak ditemukan",
  'loading': 'Memuat...',
  'pls_input_info': 'Masukkan info login.',
  "pls_input_email": " Masukkan alamat email",
  'FlowHasNotBegin': 'The event has not started yet',
  'FlowHasEnd': 'The event has ended',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "Jadilah partner Tarisland-ku sekarang!\nKlik/ketuk:",
  "copy_clipboard-text2": "(tautan eksklusif)\nJika tautan gagal, kamu bisa memasukkan kode undangan: ",
  "friends-completed": " teman sudah selesai",
  "no-friends-completed": "Tidak ada teman yang selesai",
  "pop_invitedlist_s": "SELESAI",
  "pop_invitedlist_f": "BELUM",
  "gift3": "Paket Perkembangan S1",
  "gift5": "Spirit of Frostwolf (Permanen)",
  "gift6": "Spirit of Frostwolf (1 Hari)",
  "gift1": "Gift Card senilai $100",
  "gift2": "Gift Card senilai $50",
  "gift4": "Spirit of Pyro Tiger (Permanen)",

  "invite_link_upper_limit": "Maaf, tautan undangan atau kode sudah mencapai jumlah penggunaan maksimum.",
  "invite_link_disabled": "Tautan undangan tidak valid atau kode kedaluwarsa. Tanyakan kepada pengundang.",
  "enter_your_invitation_code": "Masukkan kode undangan",
  "act_not_start": "Event belum dimulai.",
  "act_finished": "Event sudah berakhir.",
  "download_pc": "Unduh di PC",
  "email_error": "Email tidak valid. Harap periksa.",
  "loadding": "Memuat...",
  "check_my_raffle_history": "Lihat riwayat undian",
  "no_raffle_history": "Tidak ada riwayat undian",
  "system-error": "Kesalahan Sistem",
  "cant-invite-self": "Kamu tidak bisa mengundang dirimu sendiri",
}